import { Component, Input, OnInit } from '@angular/core';
import { PolicyDetailViewModel } from '@bhtp-client-web/component';

@Component({
    selector: 'agent-policy-edit-details',
    template: require('./agent-policy-edit-details.component.html')
})
export class AgentPolicyEditDetailsComponent {
    @Input() policyDetails: PolicyDetailViewModel;
    @Input() hasFees: boolean = false;
    @Input() showDestination: boolean = true;
    @Input() showTripCost: boolean = true;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/policy-edit/agent-policy-edit-details.component.ts